import { render, staticRenderFns } from "./FormBuilderContainer.vue?vue&type=template&id=50f3605c"
import script from "./FormBuilderContainer.vue?vue&type=script&lang=js"
export * from "./FormBuilderContainer.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderContainer.vue?vue&type=style&index=0&id=50f3605c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports